import React, { useState } from "react";
import kitchenBg from "../../../assets/images/banner-back-1.jpg";
import SectionHeader from "../section/SectionHeader.js";
import Kitchenimg from "../../../assets/images/Kitchen/kitch-1.jpg";
import { BiSolidPhoneCall } from "react-icons/bi";
import icon1 from "../../../assets/images/icone1.jpg";
import icon2 from "../../../assets/images/icone2.jpg";
import icon3 from "../../../assets/images/icone3.jpg";
import icon4 from "../../../assets/images/icone4.jpg";
import { FaChevronDown, FaChevronRight } from "react-icons/fa";

const About = () => {
  const [openIndex, setOpenIndex] = useState(-1);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? -1 : index);
  };
  return (
    <div className="container-fluid">
      <SectionHeader title="About" backgroundImage={kitchenBg}  />

      <div class="container my-5">
        <div class="row align-items-center">
          <div class="col-md-6" data-sal="slide-right" data-sal-duration="2000" data-sal-delay="300">
            <img
              src={Kitchenimg}
              alt="Kitchen"
              class="img-fluid w-100 rounded shadow"
            />
          </div>

          <div className="col-md-6 mt-4 mt-md-0" >
            <h2 data-sal="slide-down" data-sal-duration="2000" data-sal-delay="300"
              className="text-war fw-bold border-start border-4 ps-2 mb-2"
              style={{ borderLeft: "4px solid #d4a436", paddingLeft: "10px" }}
            >
              
              Velar Heights Renovation
            </h2>

            <h2 className="fw-bold display-6" data-sal="slide-left" data-sal-duration="2000" data-sal-delay="300">
              Over Two Decades of Excellence in Renovation
            </h2>
            <p className="text-muted" data-sal="slide-right" data-sal-duration="2000" data-sal-delay="600">
              Velar Heights Renovations stands as one of Toronto’s premier
              specialists in complete home transformations. Our highly
              experienced and licensed tradesmen work hard to ensure that what
              you ask for is exactly what you get. Whether you’re envisioning a
              new kitchen, basement, or bathroom, we bring your renovation
              dreams to life.
            </p>
            <p className="text-muted" data-sal="slide-left" data-sal-duration="2000" data-sal-delay="300">
              Transparency is a key element of what we do. We offer fixed
              pricing so that you know the exact cost of the project from
              beginning to end. We will never perform work if it has not been
              consented to by the client. We can help you at every level even if
              you have a tight budget or planning for something more generous.
            </p>

            <div className="d-flex gap-3 mt-4" data-sal="fade" data-sal-duration="2000" data-sal-delay="900">
              <a href="/contact">
              <button className="btn quote-btn btn-war fw-bold px-4 py-2 text-white shadow-sm">
                BOOK NOW
              </button>
              </a>
              <a href="tel:+16472474110">
                <button className="btn border border-warning text-war fw-bold px-4 py-2 shadow-sm  ">
                  <BiSolidPhoneCall />+1 647-247-4110
                </button>
              </a>
            </div>
          </div>
        </div>
      </div>

      <div class="container-fluid text-center my-5 ">
        <h2 class="fw-400 display-6 text-center" data-sal="slide-up" data-sal-duration="2000" data-sal-delay="600">
          Let Us Revive The Heart Of Your Home
        </h2>
        <p class="text-muted mb-5" data-sal='slide-right' data-sal-duration="2000" data-sal-delay="900">
          Transform your home with our expertly crafted bathrooms and kitchens.
          From elegance to world-class functionality, we customize every detail
          to suit your style and budget.
        </p>

        <div class="row g-4">
          <div class="col-md-6 col-lg-3" data-sal='slide-left' data-sal-duration="2000" data-sal-delay="600">
            <div class="p-4 custom-shadow bg-white rounded h-100">
              <div class="fs-1 mb-3 text-secondary">
                <img src={icon1} alt="" />
              </div>
              <h6 class="fw-bold">Great Reputation</h6>
              <p class="text-muted small">
                Renowned for excellence, our long-standing reputation is built
                on trust, reliability, and consistently delivering exceptional
                results that exceed client expectations.
              </p>
            </div>
          </div>

          <div class="col-md-6 col-lg-3" data-sal='slide-right' data-sal-duration="2000" data-sal-delay="600">
            <div class="p-4 custom-shadow bg-white rounded h-100">
              <div class="fs-1 mb-3 text-secondary">
                <img src={icon2} alt="" />
              </div>
              <h6 class="fw-bold">Skilled Experts</h6>
              <p class="text-muted small">
                Our team of seasoned professionals brings unmatched expertise
                and experience, ensuring your renovation project is executed
                with precision and care.
              </p>
            </div>
          </div>

          <div class="col-md-6 col-lg-3" data-sal='slide-left' data-sal-duration="2000" data-sal-delay="600">
            <div class="p-4 custom-shadow bg-white rounded h-100">
              <div class="fs-1 mb-3 text-secondary">
                <img src={icon3} alt="" />
              </div>
              <h6 class="fw-bold">Quality Craftsmanship</h6>
              <p class="text-muted small">
                We pride ourselves on meticulous attention to detail, delivering
                top-tier craftsmanship that reflects the highest standards in
                every aspect of your renovation.
              </p>
            </div>
          </div>

          <div class="col-md-6 col-lg-3" data-sal='slide-right' data-sal-duration="2000" data-sal-delay="600">
            <div class="p-4 custom-shadow bg-white rounded h-100">
              <div class="fs-1 mb-3 text-secondary">
                <img src={icon4} alt="" />
              </div>
              <h6 class="fw-bold">Superior Materials</h6>
              <p class="text-muted small">
                We use only the finest materials, ensuring durability, beauty,
                and long-lasting value in every renovation project we undertake.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div
        className="container-fluid py-5"
        style={{ backgroundColor: "#ebeaea" }}
      >
        <div className="container">
          <h2  data-sal='slide-down' data-sal-duration="2000" data-sal-delay="600"
            className="text-center fre fw-bold display-6 display-md-5 mb-3"
            style={{ color: "#c89b3c" }}
          >
            Frequently Asked Questions
          </h2>
          <p className="text-center text-muted mb-4 px-2 px-md-5">
            Find clear, expert answers to your most pressing renovation
            questions with our comprehensive FAQs. From timelines and local
            regulations to seasonal planning and market trends, we've got you
            covered!
          </p>

        <div className="container">
  <div
    className="accordion-item border-0 shadow-lg"
    data-sal="slide-right"
    data-sal-delay="100"
    data-sal-duration="800"
  >
    {/* First Question */}
    <h2 className="accordion-header" id="faqHeading1">
      <button
        className="fw-400"
        style={{
          backgroundColor: openIndex === 0 ? "#b78d29" : "#fff",
          color: openIndex === 0 ? "white" : "#333",
          padding: "10px",
          width: "100%",
          textAlign: "left",
          border: "none",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
        type="button"
        onClick={() => toggleAccordion(0)}
      >
        How do Toronto's Building Codes Affect My Home Renovation?
        {openIndex === 0 ? (
          <FaChevronDown style={{ marginLeft: "10px" }} />
        ) : (
          <FaChevronRight style={{ marginLeft: "10px" }} />
        )}
      </button>
    </h2>
    <div
      className="accordion-body bg-white border-start border-2 ps-3"
      style={{
        backgroundColor: "#f9f9f9",
        transition: "max-height 0.5s ease, opacity 0.5s ease",
        maxHeight: openIndex === 0 ? "500px" : "0",
        opacity: openIndex === 0 ? 1 : 0,
        overflow: "hidden",
        padding: openIndex === 0 ? "20px" : "0",
      }}
    >
      <p style={{ fontSize: "1.1rem", lineHeight: "1.6" }}>
  Toronto’s building codes are designed to ensure safety and
  quality. We stay up-to-date with all local regulations and
  obtain the necessary permits to ensure your renovation is
  compliant and hassle-free.
      </p>
    </div>
  </div>

  <div
    className="accordion-item border-0 mt-2 shadow-lg"
    data-sal="slide-left"
    data-sal-delay="100"
    data-sal-duration="800"
  >
    
    <h2 className="accordion-header" id="faqHeading2">
      <button
        className="fw-400"
        style={{
          backgroundColor: openIndex === 1 ? "#b78d29" : "#fff",
          color: openIndex === 1 ? "white" : "#333",
          padding: "10px",
          width: "100%",
          textAlign: "left",
          border: "none",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
        type="button"
        onClick={() => toggleAccordion(1)}
      >
        What Renovation Trends are Popular In Toronto Homes Right Now?
        {openIndex === 1 ? (
          <FaChevronDown style={{ marginLeft: "10px" }} />
        ) : (
          <FaChevronRight style={{ marginLeft: "10px" }} />
        )}
      </button>
    </h2>
    <div
      className="accordion-body bg-white border-start border-2 ps-3"
      style={{
        backgroundColor: "#f9f9f9",
        transition: "max-height 0.5s ease, opacity 0.5s ease",
        maxHeight: openIndex === 1 ? "500px" : "0",
        opacity: openIndex === 1 ? 1 : 0,
        overflow: "hidden",
        padding: openIndex === 1 ? "20px" : "0",
      }}
    >
      <p style={{ fontSize: "1.1rem", lineHeight: "1.6" }}>
       Popular trends include open-concept layouts, eco-friendly
  upgrades, smart home technology, and modern finishes with
  clean lines and natural tones.
      </p>
    </div>
  </div>

  <div
    className="accordion-item border-0 mt-2 shadow-lg"
    data-sal="slide-right"
    data-sal-delay="100"
    data-sal-duration="800"
  >
    {/* Third Question */}
    <h2 className="accordion-header" id="faqHeading3">
      <button
        className="fw-400"
        style={{
          backgroundColor: openIndex === 2 ? "#b78d29" : "#fff",
          color: openIndex === 2 ? "white" : "#333",
          padding: "10px",
          width: "100%",
          textAlign: "left",
          border: "none",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
        type="button"
        onClick={() => toggleAccordion(2)}
      >
        How Do You Manage Renovation Projects During Toronto’s Winter Months?
        {openIndex === 2 ? (
          <FaChevronDown style={{ marginLeft: "10px" }} />
        ) : (
          <FaChevronRight style={{ marginLeft: "10px" }} />
        )}
      </button>
    </h2>
    <div
      className="accordion-body bg-white border-start border-2 ps-3"
      style={{
        backgroundColor: "#f9f9f9",
        transition: "max-height 0.5s ease, opacity 0.5s ease",
        maxHeight: openIndex === 2 ? "500px" : "0",
        opacity: openIndex === 2 ? 1 : 0,
        overflow: "hidden",
        padding: openIndex === 2 ? "20px" : "0",
      }}
    >
      <p style={{ fontSize: "1.1rem", lineHeight: "1.6" }}>
       We plan projects to accommodate weather conditions, ensuring
  insulation and heating are prioritized to keep progress steady
  even during colder months.
      </p>
    </div>
  </div>
</div>

        </div>
      </div>
    </div>
  );
};

export default About;
